import { render, staticRenderFns } from "./PostPresentationMedia.vue?vue&type=template&id=1430ef9e&scoped=true&"
import script from "./PostPresentationMedia.vue?vue&type=script&lang=js&"
export * from "./PostPresentationMedia.vue?vue&type=script&lang=js&"
import style0 from "./PostPresentationMedia.vue?vue&type=style&index=0&id=1430ef9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1430ef9e",
  null
  
)

export default component.exports